"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var certification_1 = require("../../model/certification");
var service_1 = require("../../../library/base/service");
var SaveInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SaveInfo, _super);
    function SaveInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '保存信息';
        _this.code = '101171';
        _this.desc = '保存信息';
        _this.requestParams = new certification_1.SaveInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SaveInfo;
}(service_1.BaseService));
exports.SaveInfo = SaveInfo;
//# sourceMappingURL=saveInfo.js.map